import tailwindConfig from "#tailwind-config";

export default () => ({
  theme: computed(() => tailwindConfig.theme),
  colors: computed(() => tailwindConfig.theme.colors),
  spacing: computed(() => tailwindConfig.theme.spacing),
  screens: computed(() => tailwindConfig.theme.screens),
});
